import React from "react";
import "../Styles/Sol_Story.css";


// Correct: import CSS file separately (not as a component)


// Import your background image correctly
import HeroBackground from "../../Asserts/Oursolution.png";

const Sol_Story = () => {
  return (
    <div
      className="solutions-hero-container"
      style={{ backgroundImage: `url(${HeroBackground})` }}
    >
      {/* Header */}
      

      {/* Text */}
      <div className="solutions-overlay-text">
        <h1 className="solutions-title">Our Solutions</h1>

        <p className="hero-extra-content">
          Smart solutions aren’t just part of our work—they define it. We create innovative solutions that powers performance.
Innovative MEP solutions, exceptional after-sales support, and cutting-edge automation that enable our clients to succeed.
</p>
     
      </div>
    </div>
  );
};

export default Sol_Story;
